import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const BuoyIllustration = ({ width = 37, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 37">
      <defs>
        <path d="M0.55 0.426L37 0.426 37 36.071 0.55 36.071z" />
        <path d="M0.483 0L5.073 0 5.073 8.098 0.483 8.098z" />
        <path d="M0.483 0.902L5.072 0.902 5.072 9 0.483 9z" />
        <path d="M0.132 0.902L3.073 0.902 3.073 9 0.132 9z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#00396C"
          d="M28.975 36.071c-.455 0-.914-.037-1.375-.112l-7.672-1.256c-.763-.125-1.537-.125-2.301 0l-7.672 1.256c-2.483.406-4.951-.301-6.771-1.94-.05-.045-.1-.091-.147-.136-1.94-1.834-2.82-4.524-2.351-7.195l1.23-7.035c.137-.775.14-1.561.01-2.336L.665 9.745c-.41-2.461.304-4.906 1.958-6.71.178-.193.367-.381.562-.556C5.004.839 7.472.132 9.954.539l7.673 1.256c.764.125 1.537.125 2.3 0L27.6.539c2.483-.407 4.952.3 6.772 1.94l.148.136c1.939 1.834 2.818 4.522 2.35 7.192l-1.232 7.054c-.136.774-.14 1.56-.01 2.336l1.262 7.55c.417 2.498-.364 5.06-2.09 6.856-.137.143-.281.283-.428.416-1.483 1.335-3.396 2.052-5.397 2.052M8.582 1.543c-1.722 0-3.367.615-4.64 1.762-.17.152-.332.314-.486.48-1.4 1.528-2.028 3.687-1.68 5.778l1.263 7.572c.15.899.146 1.81-.011 2.708l-1.232 7.036c-.403 2.303.35 4.619 2.019 6.195l.127.119c1.563 1.408 3.688 2.014 5.83 1.664l7.672-1.256c.885-.145 1.783-.145 2.668 0l7.673 1.256c2.109.345 4.289-.277 5.829-1.665.128-.114.253-.235.372-.36 1.48-1.541 2.152-3.748 1.792-5.902l-1.261-7.551c-.15-.9-.146-1.81.01-2.708l1.234-7.054c.402-2.302-.352-4.618-2.02-6.194-.041-.04-.083-.08-.126-.118-1.541-1.387-3.721-2.01-5.83-1.664l-7.673 1.255c-.885.145-1.783.145-2.668 0L9.772 1.64c-.4-.065-.796-.097-1.19-.097"
        />
        <path
          fill="#ED585D"
          d="M18.778.503C8.748.503.617 8.561.617 18.5c0 9.94 8.13 17.997 18.16 17.997s17.41-8.057 17.41-17.997c0-9.939-7.38-17.997-17.41-17.997m0 28.998c-6.13 0-11.851-4.926-11.851-11.001 0-6.075 5.72-11 11.852-11 6.13 0 11.1 4.925 11.1 11s-4.97 11.001-11.1 11.001"
        />
        <path
          fill="#000"
          d="M18.778 36.497c10.03 0 17.41-8.058 17.41-17.997 0-9.94-7.38-17.997-17.41-17.997 0 0 15.84 1.436 15.84 18.16 0 16.72-15.84 17.834-15.84 17.834"
          opacity=".1"
        />
        <g transform="translate(16)">
          <path
            fill="#F9E6D8"
            d="M4.386 8.098H1.17c-.38 0-.687-.305-.687-.681V.68C.483.305.79 0 1.17 0h3.216c.379 0 .687.305.687.68v6.737c0 .376-.308.68-.687.68"
          />
        </g>
        <path
          fill="#000"
          d="M20.386 0h-2.254c.379 0 .688.305.688.681v6.736c0 .375-.309.68-.688.68h2.254c.379 0 .687-.305.687-.68V.681c0-.376-.308-.68-.687-.68"
          opacity=".1"
        />
        <g transform="translate(16 28)">
          <path
            fill="#F9E6D8"
            d="M1.17.902h3.216c.38 0 .686.305.686.681V8.32c0 .375-.307.681-.686.681H1.17c-.38 0-.687-.306-.687-.68V1.582c0-.376.307-.68.687-.68"
          />
        </g>
        <g transform="translate(18 28)">
          <path
            fill="#000"
            d="M2.386.902H.132c.379 0 .688.305.688.681V8.32C.82 8.694.511 9 .132 9h2.254c.379 0 .687-.306.687-.68V1.582c0-.376-.308-.68-.687-.68"
            opacity=".1"
          />
        </g>
        <path
          fill="#F9E6D8"
          d="M8.171 16.907v3.187c0 .376-.308.68-.687.68H.688c-.38 0-.688-.304-.688-.68v-3.187c0-.376.308-.681.688-.681h6.796c.38 0 .687.305.687.68"
        />
        <path
          fill="#000"
          d="M7.485 16.226H5.23c.379 0 .687.305.687.68v3.188c0 .376-.308.68-.687.68h2.254c.379 0 .687-.304.687-.68v-3.187c0-.376-.308-.681-.687-.681"
          opacity=".1"
        />
        <path
          fill="#F9E6D8"
          d="M36.872 16.907v3.187c0 .376-.309.68-.687.68h-6.797c-.38 0-.688-.304-.688-.68v-3.187c0-.376.308-.681.688-.681h6.797c.378 0 .687.305.687.68"
        />
        <path
          fill="#000"
          d="M36.185 16.226H33.93c.38 0 .688.305.688.68v3.188c0 .376-.308.68-.688.68h2.254c.379 0 .687-.304.687-.68v-3.187c0-.376-.308-.681-.687-.681"
          opacity=".1"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
